<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-09-29 00:24:59
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-24 14:25:29
 * @Description: file content
 -->
<template>
  <div class="share_mask">
    <div class="share_line">
      <span></span>
      <img src="http://img.ruthus.com/activies/mfAct/sharelight.png" alt />
    </div>
    <div class="phone">
      <img src="http://img.ruthus.com/activies/mfAct/phone.png" alt />
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {};
  },
  watch: {},
  methods: {}
};
</script>
<style lang="css" scoped>
.share_mask {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1000;
}

.share_mask .share_line {
  position: absolute;
  top: 0px;
  right: 0;
  z-index: 9;
  width: 50%;
}

.share_mask .share_line > span {
  width: 4px;
  height: 4px;
  border-radius: 30%;
  background-color: #fff;
  position: absolute;
  bottom: 40px;
  left: 40px;
  display: inline-block;
  z-index: 8;
  -webkit-animation: sroll 3s infinite;
  animation: sroll 3s infinite;
}

@keyframes sroll {
  0% {
    transform: translate(0px, 0px);
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }

  100% {
    opacity: 0.3;
    transform: translate(180px, -200px);
  }
}

@keyframes scaol {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.05);
    opacity: 0.7;
  }

  80% {
    transform: scale(1.03);
    opacity: 0.75;
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.share_mask .share_line > img {
  width: 100%;
  animation: scaol 1.5s infinite;
}

.share_mask .phone {
  position: absolute;
  bottom: 240px;
  left: 50px;
  margin-left: -100px;
  z-index: 9;
  width: 200px;
  opacity: 0.5;
  display: none;
}

.share_mask .phone > img {
  width: 200px;
}

.share_mask .phone > p {
  color: #fff;
  text-align: center;
  font-size: 10px;
  line-height: 28px;
}
</style>
